import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, Fab, Divider } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import InstagramIcon from '@mui/icons-material/Instagram';
import RoomIcon from '@mui/icons-material/Room';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import LanguageIcon from '@mui/icons-material/Language';
import FacebookIcon from '@mui/icons-material/Facebook';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { SvgIcon } from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ArrowRight, ArrowRightAltOutlined, ArrowRightOutlined, BookOnlineOutlined, BorderBottom, LockClock, LockRounded } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { baseURL } from 'utils/api';
import dummyImage from "assets/images/2665820.jpg"
import Loading from 'components/ApnaLoading';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { color } from 'framer-motion';

const Profile = ({ data }) => {

    const [offerData, setOfferData] = useState([]);
    const id = localStorage.getItem("id");
    const [loading, setLoading] = useState(false);
    const userTheme = useSelector((state) => state.commonSlice.theme);

    const fetchData = (ev) => {
        setLoading(true);
        fetch(`${baseURL}/get-all-templates-for-business/${id}`)
            .then((res) => res.json())
            .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                    var filterOffers = [];
                    response?.offerData?.forEach((offer) => {
                        offer?.templateLocations?.forEach((location) => {
                            if (location.locationId == ev) {
                                // Use unshift to add offer to the beginning of the array (reverse order)
                                filterOffers.unshift(offer);
                            }
                        });
                    });
                    setOfferData(filterOffers);

                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.message || 'Something went wrong');
            });
    };



    useEffect(() => {
        if (data.locationId) {
            fetchData(data.locationId);
        }
    }, [data]);


    const matches = useMediaQuery('(max-width:600px)');

    return (
        <>
            {
                loading ? <Loading /> :

                    <Box
                        sx={{
                            maxWidth: '375px',
                            margin: '0 auto',
                            height: 'auto',
                            background: 'linear-gradient(to bottom, #fff, #ffffff)',
                            // padding: matches ? 0 : 2,
                            position: 'relative',
                            border: '1px solid rgb(232, 179, 240)',
                            borderRadius: "16px",
                        }}
                    >
                        <SoftBox
                            sx={{
                                height: '300px',
                                backgroundImage: (data?.profileImage || data?.profileImage != '') ? `url(${data?.profileImage})` : `url(${dummyImage})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                borderRadius: '0 0 16px 16px',
                                position: 'relative',

                            }}
                        >
                            <Box
                                sx={{
                                    padding: matches ? 0 : 2,
                                    position: 'absolute',
                                    top: 10,
                                    left: 8,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1
                                }}>
                                <KeyboardArrowLeftIcon sx={{
                                    color: '#E68DF3', fontSize: 40,
                                    borderRadius: '50%',
                                    background: 'linear-gradient(90deg, #fff, #fff)'
                                }} />
                            </Box>
                            <Box
                                sx={{
                                    padding: matches ? 0 : 2,
                                    position: 'absolute',
                                    top: 10,
                                    right: 10,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1,
                                }}
                            >
                                <FavoriteBorderIcon sx={{ color: '#E68DF3' }} />
                            </Box>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 150,
                                    right: 10,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: '100%',
                                    gap: 0.1,
                                }}
                            >
                                <Fab
                                    size="small"
                                    color="primary"
                                    sx={{
                                        borderRadius: '0%',
                                        boxShadow: 0,
                                        background: 'linear-gradient(90deg, #AF27D2, #ED00FC )',
                                    }}
                                >
                                    <LanguageIcon />
                                </Fab>

                                <Fab
                                    size="small"
                                    color="primary"
                                    sx={{
                                        borderRadius: '0%',
                                        boxShadow: 0,
                                        background: 'linear-gradient(90deg, #AF27D2, #ED00FC )', // Updated gradient
                                    }}
                                >
                                    <InstagramIcon />
                                </Fab>

                                <Fab
                                    size="small"
                                    sx={{
                                        borderRadius: '0%',
                                        background: 'linear-gradient(90deg, #AF27D2, #ED00FC )', // Updated gradient
                                        color: '#fff',
                                        boxShadow: 0,
                                    }}
                                >
                                    <FacebookIcon />
                                </Fab>
                            </Box>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 300,
                                    left: 12,
                                    display: 'flex',
                                    gap: 1,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        background: '#E68DF3',
                                    }}
                                />
                                <Box
                                    sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        background: 'linear-gradient(90deg, #E68DF3, #3491EB)',
                                    }}
                                />
                                <Box
                                    sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        background: '#E68DF3',
                                    }}
                                />
                                <Box
                                    sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        background: '#E68DF3',
                                    }}
                                />
                                <Box
                                    sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        background: '#E68DF3',
                                    }}
                                />
                            </Box>
                        </SoftBox>
                        <SoftBox
                            sx={{
                                background: 'linear-gradient(to bottom, #fef4ff, #ffffff)',
                            }}
                        >

                            <Box sx={{ mt: -6, padding: 2 }}>
                                <Card
                                    sx={{

                                        borderRadius: 3,
                                        mt: 10,
                                        height: 'auto',
                                        mx: 'auto',
                                        border: '2px solid transparent',
                                        background: 'linear-gradient(white, white) padding-box, linear-gradient(90deg,#3491EB, #E68DF3) border-box',
                                    }}
                                >
                                    <CardContent>
                                        <SoftBox mt={1} display="flex" alignItems="center" justifyContent="space-between" >
                                            <SoftTypography
                                                variant="h1"
                                                fontWeight="bold"
                                                sx={{
                                                    fontSize: '1.2rem',
                                                    background: 'linear-gradient(90deg, #2399FA, #6F60D1)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',

                                                }}
                                            >
                                                {data?.firstName}
                                            </SoftTypography>

                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                <StarBorderIcon sx={{ fontSize: '20px', color: '#E9A2F6' }} />
                                                <SoftTypography variant="body2" fontWeight="bold" sx={{ fontSize: '0.9rem', color: 'gray' }}>
                                                    5.0
                                                </SoftTypography>
                                                <SoftTypography variant="body2" fontWeight="bold" sx={{ fontSize: '0.8rem', color: 'gray' }}>
                                                    (1)
                                                </SoftTypography>
                                            </Box>
                                        </SoftBox>

                                        <SoftBox
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexWrap: 'wrap',
                                                height: 'auto',
                                            }}
                                            mt={1}
                                        >
                                            {data?.keywords && data?.keywords.map((keyword, index) => {
                                                return (
                                                    <SoftTypography key={index} variant="caption" sx={{ display: 'inline-block', color: 'gray' }}>
                                                        {/* <span > */}
                                                        {keyword?.name != "undefined" && (keyword?.name + (index === data?.keywords.length - 1 ? ' ' : ",\u00A0"))}
                                                        {/* </span> */}
                                                    </SoftTypography>
                                                )
                                            })}
                                        </SoftBox>

                                        <SoftBox
                                            mt={1}
                                            sx={{
                                                background: 'linear-gradient(90deg, #3491EB, #E68DF3)',
                                                width: '100%',
                                                height: '1px',
                                            }}>
                                        </SoftBox>

                                        <SoftBox mt={2} display="flex" gap={5} justifyContent="center"


                                        >
                                            <SvgIcon
                                                component="svg"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                sx={{ fontSize: 60 }}
                                            >
                                                <defs>
                                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                        <stop offset="0%" style={{ stopColor: 'skyblue', stopOpacity: 1 }} />
                                                        <stop offset="100%" style={{ stopColor: 'purple', stopOpacity: 1 }} />
                                                    </linearGradient>
                                                </defs>
                                                <LocalPhoneOutlinedIcon sx={{ fill: 'url(#gradient1)', fontSize: 'inherit' }} />
                                            </SvgIcon>

                                            <SvgIcon
                                                component="svg"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                sx={{ fontSize: 60 }}
                                            >
                                                <defs>
                                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                        <stop offset="0%" style={{ stopColor: 'skyblue', stopOpacity: 1 }} />
                                                        <stop offset="100%" style={{ stopColor: 'purple', stopOpacity: 1 }} />
                                                    </linearGradient>
                                                </defs>
                                                <RoomIcon sx={{ fill: 'url(#gradient1)' }} />
                                            </SvgIcon>

                                            <SvgIcon
                                                component="svg"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                sx={{ fontSize: 60 }}
                                            >
                                                <defs>
                                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                        <stop offset="0%" style={{ stopColor: 'skyblue', stopOpacity: 1 }} />
                                                        <stop offset="100%" style={{ stopColor: 'purple', stopOpacity: 1 }} />
                                                    </linearGradient>
                                                </defs>
                                                <MailIcon sx={{ fill: 'url(#gradient1)' }} />
                                            </SvgIcon>

                                            <SvgIcon
                                                component="svg"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                sx={{ fontSize: 60 }}
                                            >
                                                <defs>
                                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                        <stop offset="0%" style={{ stopColor: 'skyblue', stopOpacity: 1 }} />
                                                        <stop offset="100%" style={{ stopColor: 'purple', stopOpacity: 1 }} />
                                                    </linearGradient>
                                                </defs>
                                                <StickyNote2Icon sx={{ fill: 'url(#gradient1)' }} />
                                            </SvgIcon>
                                        </SoftBox>

                                    </CardContent>
                                </Card>
                                {offerData && offerData.length > 0 &&
                                    <SoftBox mt={2}>
                                        <SoftTypography variant="h6" sx={{ display: 'inline-block', fontWeight: 'bold', color: '#000000' }}>
                                            EXCLUSIVELY ON 1ONUS
                                        </SoftTypography>
                                    </SoftBox>}

                                {
                                    offerData && offerData.length > 0 && offerData?.map((offer, index) => {
                                        return (
                                            <Card
                                                sx={{
                                                    mt: 2,
                                                    p: 2,
                                                    border: '2px solid transparent',
                                                    background: 'linear-gradient(white, white) padding-box, linear-gradient(90deg,#3491EB, #E68DF3) border-box',
                                                }}
                                            >
                                                <SoftBox display="flex">
                                                    <SoftBox
                                                        p={2}
                                                        pl={0}
                                                    >
                                                        {
                                                            offer?.type == "Buy One Get One"
                                                                ? <img src={require("../../../../assets/images/bogo.png")} alt="exclusive" width={50} height={60} />
                                                                : <img src={require("../../../../assets/images/offer.png")} alt="exclusive" width={50} height={60} />
                                                        }
                                                    </SoftBox>

                                                    {/* <Card
                                            sx={{
                                                background: 'rgba(255, 255, 255, 0.1)',
                                                backdropFilter: 'blur(5px)',
                                                position: 'absolute',
                                                top: 12,
                                                zIndex: 1,
                                                width: '70%',
                                                py: 2,
                                                ml: 8
                                            }}
                                        >
                                            <SoftBox
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                flexDirection="column"
                                            >
                                                <SoftBox
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    p={1}
                                                    sx={{
                                                        borderRadius: '50%',
                                                        border: '1px solid gray',
                                                    }}
                                                >
                                                    <LockRounded sx={{ color: 'gray' }} />
                                                </SoftBox>
                                                <SoftBox mt={2}>
                                                    <SoftButton variant="gradient"
                                                        color="info" sx={{
                                                            background: 'linear-gradient(90deg, #3491EB, #E68DF3)',
                                                            color: 'white',
                                                        }}>
                                                        Tap to Unlock
                                                    </SoftButton>
                                                </SoftBox>
                                            </SoftBox>
                                        </Card> */}
                                                    <SoftBox
                                                        display="flex"
                                                        flexDirection="column"
                                                        mt={1}
                                                    >
                                                        <SoftTypography variant="h6" fontWeight={800} sx={{ display: 'inline-block', color: '#000000' }}>
                                                            {offer?.name}
                                                        </SoftTypography>
                                                        <SoftTypography variant="caption" sx={{ display: 'inline-block', color: 'gray' }}>
                                                            {offer?.description}
                                                        </SoftTypography>
                                                    </SoftBox>
                                                </SoftBox>
                                            </Card>
                                        )
                                    })
                                }


                                {/* <Card
                        sx={{
                            mt: 2,
                            p: 2,
                            border: '2px solid transparent',
                            background: 'linear-gradient(white, white) padding-box, linear-gradient(90deg,#3491EB, #E68DF3) border-box',
                        }}
                    >
                        <SoftBox display="flex">
                            <SoftBox
                                p={2}
                                pl={0}
                            >
                                <img src={require("../../../../assets/images/offer.png")} alt="exclusive" width={50} height={60} />
                            </SoftBox>

                            <Card
                                sx={{
                                    background: 'rgba(255, 255, 255, 0.10)',
                                    backdropFilter: 'blur(4px)',
                                    position: 'absolute',
                                    top: 12,
                                    zIndex: 1,
                                    width: '70%',
                                    py: 2,
                                    ml: 8
                                }}
                            >
                                <SoftBox
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    flexDirection="column"
                                >
                                    <SoftBox
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        p={1}
                                        sx={{
                                            borderRadius: '50%',
                                            border: '1px solid gray',
                                        }}
                                    >
                                        <LockRounded sx={{ color: 'gray' }} />
                                    </SoftBox>
                                    <SoftBox mt={2}>
                                        <SoftButton variant="gradient"
                                            color="info" sx={{
                                                background: 'linear-gradient(90deg, #3491EB, #E68DF3)',
                                                color: 'white',
                                            }}>
                                            Tap to Unlock
                                        </SoftButton>
                                    </SoftBox>
                                </SoftBox>
                            </Card>
                            <SoftBox
                            >
                                <SoftTypography variant="h6" fontWeight={800}  sx={{ display: 'inline-block' }}>
                                    Pukka Breal
                                </SoftTypography>
                                <SoftTypography variant="caption"  sx={{ display: 'inline-block' }}>
                                    lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                    </Card> */}




                                {/* ABOUT */}

                                <SoftBox
                                    mt={3}
                                    sx={{
                                        background: 'linear-gradient(90deg, #3491EB, #E68DF3)',
                                        width: '110%',
                                        height: '1px',
                                        ml: '-5%',
                                    }}>
                                </SoftBox>


                                <SoftBox mt={2}

                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignItems: 'start',
                                        flexDirection: 'column',
                                    }}
                                >
                                    {
                                        data?.description != "" &&
                                        <SoftBox
                                        // px={2}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'start',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <SoftTypography variant="h6" fontWeight={900}
                                                sx={{ display: 'inline-block', color: '#000000' }}
                                            >
                                                About
                                            </SoftTypography>
                                            <SoftTypography variant="caption"
                                                sx={{ display: 'inline-block', color: 'gray', marginTop: 1 }}
                                            >
                                                <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                                            </SoftTypography>
                                        </SoftBox>
                                    }
                                    <SoftBox
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'start',
                                            flexDirection: 'column',
                                        }}
                                        mt={2}
                                    >
                                        {/* <SoftBox
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    gap: 16,
                                }}
                            > */}
                                        {
                                            data?.operatingHours && data?.operatingHours.length > 0 &&

                                            <Accordion
                                                sx={{
                                                    background: 'none',
                                                    boxShadow: 'none',
                                                    width: "100%",
                                                    padding: 0,
                                                }}
                                                defaultExpanded
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1-content"
                                                    id="panel1-header"
                                                    sx={{ width: "100%", padding: 0, }}

                                                >
                                                    <SoftBox
                                                        sx={{
                                                            display: 'flex',
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                background: '#F8E0F9',
                                                                borderRadius: '50%',
                                                                padding: '10px',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                color: '#333',
                                                            }}
                                                        >
                                                            <SvgIcon
                                                                component="svg"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 24 24"
                                                                sx={{ fontSize: 60 }}
                                                            >
                                                                <defs>
                                                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                                        <stop offset="0%" style={{ stopColor: 'skyblue', stopOpacity: 1 }} />
                                                                        <stop offset="100%" style={{ stopColor: 'purple', stopOpacity: 1 }} />
                                                                    </linearGradient>
                                                                </defs>
                                                                <LockClock sx={{ fill: 'url(#gradient1)' }} />
                                                            </SvgIcon>

                                                        </Box>
                                                        <SoftBox ml={2} mt={1}>
                                                            <SoftTypography variant="h6"
                                                                sx={{ color: '#000000' }}
                                                            >
                                                                Operating Hours
                                                            </SoftTypography>
                                                        </SoftBox>
                                                    </SoftBox>
                                                </AccordionSummary>
                                                <AccordionDetails
                                                    sx={{
                                                        padding: 0,
                                                        paddingLeft: 1,
                                                    }}
                                                >
                                                    <Box sx={{ flexGrow: 1, width: 310 }} />
                                                    <SoftBox
                                                        sx={{
                                                            width: 230,
                                                            // paddingRight: 8,
                                                            // marginRight: 8,
                                                            // paddingLeft: 2,
                                                        }}
                                                    >


                                                        {
                                                            data?.operatingHours?.map((operatingHour, index) => {
                                                                return (
                                                                    <SoftBox key={index} display="flex" justifyContent="space-between" gap={5} >
                                                                        <SoftTypography
                                                                            sx={{
                                                                                mt: 1,
                                                                                fontSize: 14,
                                                                                color: 'gray'
                                                                            }}
                                                                            variant="caption"  >
                                                                            {operatingHour?.day}
                                                                        </SoftTypography>
                                                                        <SoftTypography
                                                                            sx={{
                                                                                mt: 1,
                                                                                color: 'gray'
                                                                            }}
                                                                            variant="caption"  >
                                                                            {operatingHour?.openingHours ? (operatingHour?.openingHours + '-' + operatingHour?.closingHours) : "Closed"}
                                                                            <br />
                                                                            {
                                                                                operatingHour?.secondOpeningHours && (operatingHour?.secondOpeningHours + "-" + operatingHour?.secondClosingHours)
                                                                            }
                                                                        </SoftTypography>

                                                                    </SoftBox>
                                                                )
                                                            }
                                                            )
                                                        }
                                                    </SoftBox>
                                                </AccordionDetails>
                                            </Accordion>
                                        }

                                    </SoftBox>
                                    <SoftBox
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'start',
                                            flexDirection: 'column',
                                        }}
                                        mt={2}
                                    >

                                        {
                                            (data?.termsAndConditions && data?.termsAndConditions != "") &&

                                            <Accordion
                                                defaultExpanded
                                                sx={{
                                                    background: 'none',
                                                    boxShadow: 'none',
                                                    padding: 0,
                                                    width: "100%",
                                                }}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1-content"
                                                    id="panel1-header"
                                                    sx={{ padding: 0, width: "100%", }}
                                                >
                                                    <SoftBox
                                                        sx={{
                                                            display: 'flex',
                                                            width: "100%",
                                                            // justifyContent:"space-between",
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                background: '#F8E0F9',
                                                                borderRadius: '50%',
                                                                padding: '10px',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                color: '#333',
                                                            }}
                                                        >
                                                            <SvgIcon
                                                                component="svg"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 24 24"
                                                                sx={{ fontSize: 60 }}
                                                            >
                                                                <defs>
                                                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                                        <stop offset="0%" style={{ stopColor: 'skyblue', stopOpacity: 1 }} />
                                                                        <stop offset="100%" style={{ stopColor: 'purple', stopOpacity: 1 }} />
                                                                    </linearGradient>
                                                                </defs>
                                                                <BookOnlineOutlined sx={{ fill: 'url(#gradient1)' }} />
                                                            </SvgIcon>

                                                        </Box>
                                                        <SoftBox
                                                            sx={{
                                                                ml: 2,   // Add space between icon and text
                                                                flexGrow: 1,  // Push text to the left
                                                                mt: 1,
                                                            }}
                                                        >
                                                            <SoftTypography variant="h6"
                                                                sx={{ color: '#000000' }}
                                                            >
                                                                Terms and Conditions
                                                            </SoftTypography>
                                                        </SoftBox>
                                                    </SoftBox>
                                                </AccordionSummary>
                                                <AccordionDetails

                                                    sx={{
                                                        paddingLeft: 2,
                                                        // marginRight: 8, 
                                                    }}>
                                                    <Box sx={{ flexGrow: 1, width: 310 }} />
                                                    <SoftTypography
                                                        variant="caption"
                                                        sx={{ color: 'gray' }}
                                                        dangerouslySetInnerHTML={{ __html: data?.termsAndConditions }} />

                                                </AccordionDetails>
                                            </Accordion>
                                        }


                                    </SoftBox>
                                </SoftBox>

                                <SoftBox
                                    mt={3}
                                    mb={2}
                                    sx={{
                                        background: 'linear-gradient(90deg, #3491EB, #E68DF3)',
                                        width: '110%',
                                        height: '1px',
                                        ml: '-5%',
                                    }}>
                                </SoftBox>

                                {
                                    data?.amenities && data?.amenities.length > 0 &&



                                    <SoftBox
                                        sx={{
                                            width: "100%",
                                            height: 'auto',
                                            mx: 'auto',
                                            background: 'none',

                                        }}
                                    >

                                        <SoftTypography
                                            variant="h6"
                                            sx={{ color: '#000000' }}
                                        >
                                            Amenities
                                        </SoftTypography>

                                        <SoftBox mt={2} display="flex" flexWrap="wrap" gap={1}


                                        >
                                            {data?.amenities?.map((amenity, index) => (
                                                <SoftBox
                                                    key={index}
                                                    display="flex"
                                                    flexDirection="column"
                                                    alignItems="center"
                                                    sx={{
                                                        width: '60px',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            background: '#F8E0F9',
                                                            borderRadius: '50%',
                                                            padding: '10px',

                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            color: '#333',
                                                        }}
                                                    >
                                                        <img
                                                            src={amenity?.amenityLogo}
                                                            alt={amenity?.name}
                                                            style={{ width: '32px', height: '32px' }}
                                                        />

                                                    </Box>
                                                    <SoftTypography variant="caption" mt={1}
                                                        sx={{ color: 'gray' }}
                                                    >
                                                        {amenity?.name}
                                                    </SoftTypography>
                                                </SoftBox>
                                            ))}
                                        </SoftBox>
                                    </SoftBox>
                                }
                                <SoftBox mt={3}>
                                    <SoftTypography variant="caption" sx={{ display: 'inline-block', textAlign: "center" ,color:"gray"}}>
                                        If you are a manager and would like to make edits to your listing, please <u style={{ color: "#c21fad" }}>Click here</u> to contact us.
                                    </SoftTypography>
                                </SoftBox>


                                <SoftBox
                                    mt={3}
                                    mb={2}
                                    sx={{
                                        background: 'linear-gradient(90deg, #3491EB, #E68DF3)',
                                        width: '110%',
                                        height: '1px',
                                        ml: '-5%',
                                    }}>
                                </SoftBox>

                                <SoftBox mt={2}>

                                    <SoftBox
                                        sx={{
                                            BorderBottom: 'linear-gradient(90deg, #3d94da, #c21fad) 1px solid',
                                        }}
                                    ></SoftBox>

                                    <SoftTypography variant="caption" sx={{ display: 'inline-block', textAlign: "center", color: "gray" }}>
                                        Help us make <span style={{ color: "#c21fad" }}>10NUS</span> better <u style={{ color: "#c21fad" }}>Report and issue</u> with the listing to help us stay up to date.
                                    </SoftTypography>

                                </SoftBox>
                            </Box>
                        </SoftBox >
                    </Box >
            }
        </>
    );
};

export default Profile;


